<div class="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-xl">
  <!-- Header Section -->
  <div class="text-center mb-10 border-b pb-6 relative">
    <!-- 🆕 Botón de descarga -->
    <div class="absolute right-0 top-0">
      <button (click)="downloadPdf()" [disabled]="isDownloadingPdf"
        class="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-2 px-4 rounded inline-flex items-center text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        <svg *ngIf="!isDownloadingPdf" class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20">
          <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
        </svg>
        <svg *ngIf="isDownloadingPdf" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        {{ isDownloadingPdf ? 'Descargando...' : 'Descargar PDF' }}
      </button>
    </div>
    <h1 class="text-3xl font-bold text-gray-800">Reporte de Comprobante de Egreso #{{ expenseVouchersData.id }}</h1>
    <p class="mt-2 text-gray-500">Fecha de Pago: {{ expenseVouchersData.dateExpenseVoucher | date }}</p>

    <!-- 🆕 Estados de Conciliación del Comprobante -->
    <div class="mt-4 flex flex-wrap justify-center gap-2">
      <div class="inline-block px-3 py-1 bg-green-100 rounded-full text-green-800 text-xs font-semibold">
        <i class="fas fa-check-circle mr-1"></i>PAGADO
      </div>

      <div *ngIf="expenseVouchersData.isBankReconciled"
        class="inline-block px-3 py-1 bg-green-100 rounded-full text-green-800 text-xs font-semibold">
        <i class="fas fa-university mr-1"></i>CONCILIADO BANCARIAMENTE
      </div>

      <div *ngIf="expenseVouchersData.isManualConciliated"
        class="inline-block px-3 py-1 bg-blue-100 rounded-full text-blue-800 text-xs font-semibold">
        <i class="fas fa-hand-paper mr-1"></i>CONCILIADO MANUALMENTE
      </div>

      <div *ngIf="!expenseVouchersData.isBankReconciled && !expenseVouchersData.isManualConciliated"
        class="inline-block px-3 py-1 bg-red-100 rounded-full text-red-800 text-xs font-semibold">
        <i class="fas fa-times-circle mr-1"></i>SIN CONCILIAR
      </div>
    </div>
  </div>

  <!-- Beneficiary Section -->
  <div class="mb-10 bg-gray-50 p-6 rounded-xl">
    <h2 class="text-xl font-semibold text-gray-800 mb-4">Datos del Beneficiario</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
      <p><span class="font-medium">Nombre:</span> {{ expenseVouchersData.thirdParties.firstName }} {{
        expenseVouchersData.thirdParties.lastName }}</p>
      <p><span class="font-medium">Documento:</span> {{ expenseVouchersData.thirdParties.typeDocument }} - {{
        expenseVouchersData.thirdParties.documentId }}</p>
      <p><span class="font-medium">Teléfono:</span> {{ expenseVouchersData.thirdParties.phone }}</p>
      <p><span class="font-medium">Celular:</span> {{ expenseVouchersData.thirdParties.cellPhone }}</p>
      <p><span class="font-medium">Email:</span> {{ expenseVouchersData.thirdParties.email }}</p>
      <p class="md:col-span-2"><span class="font-medium">Dirección:</span> {{
        expenseVouchersData.thirdParties.addressLine1 }} {{ expenseVouchersData.thirdParties.addressLine2 }}, {{
        expenseVouchersData.thirdParties.city }}, {{ expenseVouchersData.thirdParties.country }}</p>
      <p class="md:col-span-2"><span class="font-medium">Observaciones:</span> {{
        expenseVouchersData.thirdParties.observations }}</p>
    </div>
  </div>

  <!-- Bank Section -->
  <div class="mb-10 bg-blue-50 p-6 rounded-xl border border-blue-200">
    <h2 class="text-xl font-semibold text-gray-800 mb-4">Datos del Banco</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
      <p><span class="font-medium">Banco:</span> {{ expenseVouchersData.bank?.bankName || 'N/A' }}</p>
      <p><span class="font-medium">Número de Cuenta:</span> {{ expenseVouchersData.bank?.accountNumber || 'N/A' }}</p>
    </div>
  </div>

  <!-- Expense Voucher Items Section -->
  <div class="space-y-6">
    <div *ngFor="let item of expenseVouchersData.expenseVouchersItems" class="border rounded-lg p-6 bg-white shadow-sm">
      <h2 class="text-xl font-semibold mb-4 text-gray-800">Órden de Trabajo #{{item.workOrders.id}}</h2>

      <div class="space-y-4">
        <div>
          <p class="text-sm font-medium text-gray-600">Detalles</p>
          <p class="text-gray-800">{{ item.details }}</p>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-6 gap-4 mb-4">

          <div>
            <p class="text-sm font-medium text-gray-600">Fecha de Pago</p>
            <p class="text-gray-800">{{ item.workOrders.paymentDate | date }}</p>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-600">Total Base</p>
            <p class="text-gray-800 font-medium">{{ item.workOrders.totalBaseAmount | currency }}</p>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-600">Total IVA</p>
            <p class="text-gray-800 font-medium">{{ item.workOrders.totalVatAmount | currency }}</p>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-600">Total Bruto</p>
            <p class="text-gray-800 font-medium">{{ item.workOrders.totalAmount | currency }}</p>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-600">Total Descuentos</p>
            <p class="text-red-600 font-medium">{{ item.workOrders.totalDiscount | currency }}</p>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-600">Total Neto</p>
            <p class="text-green-600 font-medium">{{ item.workOrders.totalToPay | currency }}</p>
          </div>
        </div>



        <!-- Work Order Items Table -->
        <div class="mt-6">
          <h3 class="text-lg font-semibold mb-4">Items de la Orden de Trabajo</h3>
          <div class="overflow-x-auto rounded-lg border">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Proyecto</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Categoría</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Subcategoría</th>
                  <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Valor Unitario</th>
                  <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Cantidad</th>
                  <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">IVA</th>
                  <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Monto Ejecutado</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr *ngFor="let workOrderItem of item.workOrders.workOrderItems">
                  <td class="px-4 py-3 text-sm text-gray-800">{{ workOrderItem.projectBudget.project.projectId }}-{{
                    workOrderItem.projectBudget.project.name }}</td>
                  <td class="px-4 py-3 text-sm text-gray-600">{{
                    workOrderItem.projectBudget.budgetSubcategory.budgetCategory.name }}</td>
                  <td class="px-4 py-3 text-sm text-gray-600">{{ workOrderItem.projectBudget.budgetSubcategory.name }}
                  </td>
                  <td class="px-4 py-3 text-sm text-right text-gray-800">{{ workOrderItem.unitValue | currency }}</td>
                  <td class="px-4 py-3 text-sm text-right text-gray-800">{{ workOrderItem.qty }}</td>
                  <td class="px-4 py-3 text-sm text-right text-gray-800">{{ workOrderItem.vatAmount | currency }}</td>
                  <td class="px-4 py-3 text-sm text-right font-medium text-blue-800">{{ workOrderItem.executedAmount |
                    currency }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Discounts Section -->
  <div class="bg-red-50 p-4 rounded-lg mt-5">
    <h3 class="text-lg font-semibold text-red-800 mb-3">Descuentos practicados al comprobante de egreso</h3>
    <div class="space-y-2">
      <div *ngFor="let fee of expenseVouchersData.feeDetails"
        class="flex justify-between items-center bg-white p-3 rounded-md shadow-xs">
        <div>
          <p class="font-medium text-gray-700">{{ fee.feeType.name }}</p>
          <p class="text-sm text-gray-500">{{ fee.feeType.description }}</p>
        </div>
        <div class="text-right">
          <p class="text-red-600 font-medium">-{{ fee.amount | currency }}</p>
          <p class="text-sm text-gray-500">{{ fee.porcentualAmount }}%</p>
        </div>
      </div>
    </div>
  </div>

  <!-- 🆕 Información de Conciliación -->
  <div *ngIf="expenseVouchersData.isBankReconciled || expenseVouchersData.isManualConciliated"
    class="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400 mt-6">
    <h3 class="text-lg font-semibold mb-3 text-blue-800">
      <i class="fas fa-check-circle mr-2"></i>Información de Conciliación
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
      <div *ngIf="expenseVouchersData.isBankReconciled">
        <p class="font-medium text-blue-600">Conciliación Bancaria:</p>
        <p class="text-blue-800">✅ Conciliado</p>
        <p *ngIf="expenseVouchersData.bankReconciledAt" class="text-xs text-blue-600">{{
          expenseVouchersData.bankReconciledAt | date:'medium' }}</p>
        <p *ngIf="expenseVouchersData.bankReconciledBy" class="text-xs text-blue-600">Por: {{
          expenseVouchersData.bankReconciledBy }}</p>
      </div>
      <div *ngIf="expenseVouchersData.isManualConciliated">
        <p class="font-medium text-blue-600">Conciliación Manual:</p>
        <p class="text-blue-800">✅ Conciliado manualmente</p>
      </div>
    </div>
  </div>

  <!-- Estado de Conciliación Section -->
  <div class="mt-6 bg-gray-50 p-4 rounded-lg">
    <h3 class="text-lg font-semibold mb-3 text-gray-700">Estado del Comprobante</h3>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
      <div>
        <p class="font-medium text-gray-600">Estado de Conciliación:</p>
        <div class="flex flex-wrap gap-1 mt-1">
          <span *ngIf="expenseVouchersData.isBankReconciled"
            class="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
            <i class="fas fa-university mr-1"></i>BANCARIA
          </span>
          <span *ngIf="expenseVouchersData.isManualConciliated"
            class="px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
            <i class="fas fa-hand-paper mr-1"></i>MANUAL
          </span>
          <span *ngIf="!expenseVouchersData.isBankReconciled && !expenseVouchersData.isManualConciliated"
            class="px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
            <i class="fas fa-times-circle mr-1"></i>SIN CONCILIAR
          </span>
        </div>
      </div>
      <div>
        <p class="font-medium text-gray-600">Número de Comprobante:</p>
        <p class="text-gray-800 font-mono">#{{ expenseVouchersData.id }}</p>
      </div>
      <div>
        <p class="font-medium text-gray-600">Fecha de Creación:</p>
        <p class="text-gray-800 font-mono">{{ expenseVouchersData.createdAt | date:'mediumDate' }}</p>
      </div>
      <div>
        <p class="font-medium text-gray-600">Fecha de Pago:</p>
        <p class="text-gray-800">{{ expenseVouchersData.dateExpenseVoucher | date:'mediumDate' }}</p>
      </div>
    </div>
  </div>

  <!-- Total Amount Section -->
  <div class="mt-10 pt-6 border-t">
    <div class="max-w-xs ml-auto space-y-3">
      <div class="flex justify-between">
        <span class="font-medium text-gray-600">Valor Bruto:</span>
        <span class="font-medium text-gray-800">{{ expenseVouchersData.totalAmount | currency }}</span>
      </div>
      <div class="flex justify-between">
        <span class="font-medium text-gray-600">Descuentos:</span>
        <span class="font-medium text-red-600">-{{ expenseVouchersData.totalDiscount | currency }}</span>
      </div>
      <div class="flex justify-between pt-2 border-t">
        <span class="font-bold text-gray-800">Total a Pagar:</span>
        <span class="font-bold text-green-600">{{ expenseVouchersData.totalToPay | currency }}</span>
      </div>
    </div>
  </div>
</div>